import { useSetAtom } from 'jotai'
import React from 'react'
import * as R from 'remeda'
import { z } from 'zod'

import { brandGroupIdAtom } from '~/atoms'
import { setValueIfExist } from '~/utils'

import {
  dataDisplayTypeAtom,
  fiveSegmentCommentAtom,
  fiveSegmentHiddenColumnKeysAtom,
  fiveSegmentSortValueAtom,
  hiddenRowIdsAtom,
  nineSegmentCommentAtom,
  nineSegmentHiddenColumnKeysAtom,
  nineSegmentSortValueAtom,
  savedFiveSegmentCommentAtom,
  savedNineSegmentCommentAtom,
  segmentDisplayTypeAtom,
} from '../../atoms'

import { schema1 } from './schemas/schema1'
import { schema2 } from './schemas/schema2'

const schema = z.union([schema1, schema2])

export const useRestoreParams = () => {
  const setBrandGroupId = useSetAtom(brandGroupIdAtom)

  const setDataDisplayType = useSetAtom(dataDisplayTypeAtom)
  const setSegmentDisplayType = useSetAtom(segmentDisplayTypeAtom)
  const setFiveSegmentComment = useSetAtom(fiveSegmentCommentAtom)
  const setSavedFiveSegmentComment = useSetAtom(savedFiveSegmentCommentAtom)

  const setFiveSegmentSortValue = useSetAtom(fiveSegmentSortValueAtom)
  const setNineSegmentComment = useSetAtom(nineSegmentCommentAtom)
  const setSavedNineSegmentComment = useSetAtom(savedNineSegmentCommentAtom)
  const setNineSegmentSortValue = useSetAtom(nineSegmentSortValueAtom)

  const setHiddenRowIds = useSetAtom(hiddenRowIdsAtom)

  const setFiveSegmentHiddenColumnKeys = useSetAtom(
    fiveSegmentHiddenColumnKeysAtom,
  )
  const setNineSegmentHiddenColumnKeys = useSetAtom(
    nineSegmentHiddenColumnKeysAtom,
  )

  return React.useCallback(
    (state: unknown) => {
      const parsed = schema.safeParse(state)
      if (!parsed.success) {
        return null
      }
      const params = parsed.data

      setValueIfExist(params.brandGroupId, setBrandGroupId)
      setValueIfExist(params.dataDisplayType, setDataDisplayType)
      setValueIfExist(params.segmentDisplayType, setSegmentDisplayType)
      setValueIfExist(params.fiveSegmentComment, setFiveSegmentComment)
      setValueIfExist(params.fiveSegmentComment, setSavedFiveSegmentComment)
      setValueIfExist(params.fiveSegmentSortValue, setFiveSegmentSortValue)
      setValueIfExist(params.nineSegmentComment, setNineSegmentComment)
      setValueIfExist(params.nineSegmentComment, setSavedNineSegmentComment)
      setValueIfExist(params.nineSegmentSortValue, setNineSegmentSortValue)
      setValueIfExist(params.hiddenRowIds, setHiddenRowIds)
      setValueIfExist(
        params.fiveSegmentHiddenColumnKeys,
        setFiveSegmentHiddenColumnKeys,
      )
      setValueIfExist(
        params.nineSegmentHiddenColumnKeys,
        setNineSegmentHiddenColumnKeys,
      )

      return R.pick(params, ['hash'])
    },
    [
      setBrandGroupId,
      setDataDisplayType,
      setFiveSegmentComment,
      setFiveSegmentHiddenColumnKeys,
      setFiveSegmentSortValue,
      setHiddenRowIds,
      setNineSegmentComment,
      setNineSegmentHiddenColumnKeys,
      setNineSegmentSortValue,
      setSavedFiveSegmentComment,
      setSavedNineSegmentComment,
      setSegmentDisplayType,
    ],
  )
}
